import { IVeeValidateRules } from "../validation/i-vee-validate-rules"

/**
 * Validation object for password validation rules
 */
export const PasswordRules: IVeeValidateRules = {
  /**
   * This Validation is required
   */
  required: true,
  /**
   * Min password length
   */
  min: 12,
  /**
   * Max password length
   */
   max: 100
}